import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { colors } from '../styles/theme';

/**
 * Pantalla completa mientras baja el código de una vista compartida o de lista.
 * Mismo fondo y spinner que el overlay inicial de esas páginas: no hay salto.
 */
export default function PageBootScreen() {
  return (
    <Box
      aria-busy="true"
      sx={{
        position: 'fixed',
        inset: 0,
        bgcolor: colors.pageBootBackground,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress sx={{ color: 'common.white' }} />
    </Box>
  );
}
